import { useState } from "react";
import { useNavigate } from "react-router";
import { BusinessPage } from "core/constants";
import { logApiError } from "core/lib";
import { ModalAlert } from "core/lib/show-modal";
import { updateProfileAsync } from "core/lib/update-profile";
import User, { getUser } from "core/models/user";
import CaptureUserDetailsForm from "components/capture-user-details-form";

type ManageProfileProps = {
    title?: string,
    cssClassName?: string
}

const ManageProfile = (props: ManageProfileProps) => {
    const navigate = useNavigate();

    const { title, cssClassName } = props;
    const [display, setDisplay] = useState<boolean>(true);

    const onSubmit = async (firstName: string, lastName: string) => {
        if (!User.instance) {
            getUser();
        }

        const existingDialog = ModalAlert.loading("Updating profile");

        try {
            await updateProfileAsync(firstName, lastName);

            setDisplay(false);

            ModalAlert.close(existingDialog);

            const onClose = () => {
                navigate(BusinessPage.dashboard);
            }

            ModalAlert.success("Update", "Profile updated successfully", { onClose: onClose });
        } catch (error) {
            logApiError(error);

            setDisplay(true);

            ModalAlert.close(existingDialog);
            ModalAlert.error("Error updating profile");
        }
    }

    return <CaptureUserDetailsForm
        title={title}
        cssClassName={cssClassName}
        isClosable={false}
        display={display}
        canCancel={false}
        onSubmit={onSubmit} />
}

export default ManageProfile;
